var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1052,
    height: 770,
    viewBox: "0 0 1052 770",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.517 270.978L622.742 97.5596C802.679 32.0677 926.36 104.25 969.368 222.415C1012.38 340.579 948.912 482.197 784.517 542.033L310.913 714.41",
    stroke: "white",
    strokeWidth: 69,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.176 404.237L597.424 225.313",
    stroke: "#A0A0A0",
    strokeWidth: 38,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7422 548.145L824.099 277.949",
    stroke: "white",
    strokeWidth: 49,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M195.365 641.04L683.613 462.116",
    stroke: "#A0A0A0",
    strokeWidth: 38,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2287ee2310900e989635de5b364060e4.svg";
export { ForwardRef as ReactComponent };